export const vertexShader = `
  varying vec2 vUv;
  uniform float direction; // -1 or 1

  void main() {
    vUv = uv;
    vec3 transformedPosition = position;
    transformedPosition.x *= direction;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(transformedPosition, 1.0);
  }
`;

export const fragmentShader = `
  uniform vec3 color;
  uniform float progress;
  uniform float globalProgress;
  uniform float strokeWidth;
  uniform float randomSeed;

  varying vec2 vUv;

  #define PI 3.1415926535

  vec4 conicGradient(vec4 color) {
    vec2 centeredUv = vUv - 0.5;

    float angle = atan(centeredUv.y, centeredUv.x) + (randomSeed * PI * 2.);
    float normalizedAngle = (angle + PI) / (2.0 * PI);

    normalizedAngle += progress;
    normalizedAngle = mod(normalizedAngle, 1.0);
    normalizedAngle = 1. - normalizedAngle;

    float gradient = smoothstep(0.3, 1.0, normalizedAngle * .5);

    return vec4(color.rgb, gradient);
  }

  vec3 desaturate(vec3 color, float amount) {
    return mix(color, vec3(1.0), amount);
  }

  void main() {
    vec2 centeredUv = vUv - 0.5;

    float dist = length(centeredUv);

    float radius = 0.5;
    float strokeWidth = 0.005 * strokeWidth;

    if (dist > radius || dist < radius - strokeWidth) {
      discard;
    }

    vec4 fillColor = conicGradient(vec4(color, 1.0));

    fillColor.rgb = desaturate(fillColor.rgb, smoothstep(0.7, 1.0, globalProgress));
    fillColor.rgb *= 1. + smoothstep(0.7, 1.0, globalProgress);

    fillColor.a *= smoothstep(.05, 1., globalProgress) * 10.;
    fillColor.a *= max(0., 1. - progress); // fade out

    gl_FragColor = fillColor;
}
`;

